export const formDefaultValues = {
  name: 'Mensaje de cumpleaños',
  body: '',
}
